import { Box, Button } from "@mui/material";
import React from "react";
import { MahaloAiStarIcon } from "../../Common/assets/Icons";
import AiSearchModal from "./AiSearchModal";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { setShowAiSearchModal } from "../../../Redux/reducers/aiSearchSlice";

const AiSearch = () => {
  const dispatch = useAppDispatch();

  const showModal = useAppSelector((state) => state.aiSearch.showAiSearchModal);

  const toggleModal = () => {
    dispatch(setShowAiSearchModal(!showModal));
  };

  const closeModal = () => {
    dispatch(setShowAiSearchModal(false));
  };

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "50px",
            height: "40px",
            border: "2px solid #872EE5",
            // borderImageSource: "linear-gradient(90deg, #872EE5 0%, #190DD7 100%)",
            // borderImageSlice: 1,
            borderRight: "none",
            borderRadius: "8px 0px 0px 8px",
            cursor: "pointer",
          }}
          onClick={toggleModal}
        >
          <MahaloAiStarIcon />
        </Box>
        <Button
          variant="contained"
          onClick={toggleModal}
          sx={{
            background: "linear-gradient(90deg, #872EE5 0%, #190DD7 100%)",
            borderRadius: "0px 8px 8px 0px",
          }}
        >
          AI Search
        </Button>
      </Box>
      {showModal && (
        <AiSearchModal
          showModal={showModal}
          closeModal={closeModal}
          data={null}
        />
      )}
    </Box>
  );
};

export default AiSearch;
